import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names with conflict resolution.
 *
 * Layout utilities (flex, p-6, gap-2) are composed via Tailwind.
 * Aesthetic tokens (colors, typography, radius, shadows) MUST use
 * CSS custom properties — see `@grt/bodykit/theme`.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
